import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase/firebase";

export default function useTutorPackets() {
  const [packets, setPackets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAssignments = async () => {
      try {
        /* ---------- PACKETS ---------- */

        const packetsSnap = await getDocs(
          query(collection(db, "packets"), orderBy("createdAt", "desc"))
        );

        const packetStatsSnap = await getDocs(
          collection(db, "packetStats")
        );

        const packetStatsMap = {};
        packetStatsSnap.forEach((doc) => {
          packetStatsMap[doc.id] = doc.data();
        });

        const packetAssignments = packetsSnap.docs.map((doc) => {
          const data = doc.data();
          const stats = packetStatsMap[doc.id] || {};

          return {
            id: doc.id,
            type: "packet",

            category: data.section === "Math" ? "Math" : "Reading",
            title: data.name,
            subtitle: data.levelLabel || data.difficultyLabel || "",
            problemCount: data.questionIds?.length || 0,
            assignedCount: stats.assignedCount || 0,
            starred: data.starred || false,

            testType: data.testType || "SAT",
            section: data.section,
            subSection: data.primaryCategory || "Mixed",
          };
        });

        /* ---------- DIAGNOSTICS ---------- */

        const diagnosticsSnap = await getDocs(
          query(collection(db, "diagnostics"), orderBy("createdAt", "desc"))
        );

        const diagnosticAssignments = diagnosticsSnap.docs.map((doc) => {
          const data = doc.data();

          return {
            id: doc.id,
            type: "diagnostic",

            category: data.section === "Math" ? "Math" : "Reading",
            title: data.name || "Diagnostic",
            subtitle: "Diagnostic",
            problemCount: data.questionCount || 0,
            assignedCount: data.assignedCount || 0,
            starred: false,

            testType: data.testType || "SAT",
            section: data.section,
            subSection: "Diagnostic",
          };
        });

        /* ---------- COMBINE ---------- */

        setPackets([
          ...diagnosticAssignments,
          ...packetAssignments,
        ]);
      } catch (err) {
        console.error("Failed to load assignments:", err);
      } finally {
        setLoading(false);
      }
    };

    loadAssignments();
  }, []);

  return { packets, setPackets, loading };
}
